import {
  Gift, Wrench, Handshake, Compass, Trophy, Medal, Star, Crown, Fire,
  Lightning, RocketLaunch, Heart, Coins, Package, Hammer, Target,
  Sparkle, Storefront, Key, ThumbsUp,
} from "@phosphor-icons/react";

export const ACHIEVEMENT_ICONS = {
  gift: Gift, wrench: Wrench, handshake: Handshake, compass: Compass,
  trophy: Trophy, medal: Medal, star: Star, crown: Crown, fire: Fire,
  lightning: Lightning, rocket: RocketLaunch, heart: Heart, coins: Coins,
  package: Package, hammer: Hammer, target: Target, sparkle: Sparkle,
  storefront: Storefront, key: Key, thumbsup: ThumbsUp,
};

export const ICON_KEYS = Object.keys(ACHIEVEMENT_ICONS);

const isUrl = (s) => typeof s === "string" && /^https?:\/\//.test(s);

export function AchievementIcon({ icon, size = 24, weight = "fill", className = "", style = {} }) {
  if (isUrl(icon)) {
    return <img src={icon} alt="" width={size} height={size} className={className} style={{ objectFit: "contain", ...style }} />;
  }
  const Cmp = ACHIEVEMENT_ICONS[icon] || Trophy;
  return <Cmp size={size} weight={weight} className={className} style={style} />;
}
